import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import SubMenuThreeDotIcon from "../../../../../components/icons/SubMenuThreeDotIcon";
import "./PropertyPlatformPostMenuIcon.scss";

const PropertyPlatformPostMenuIcon = ({
  disabled,
  onPublishNow,
  onSchedulePost,
  onCancelSchedule,
  onRetryPost,
  onViewErrors,
}: {
  disabled?: boolean;
  onPublishNow?: () => void;
  onSchedulePost?: () => void;
  onCancelSchedule?: () => void;
  onRetryPost?: () => void;
  onViewErrors?: () => void;
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [loading] = React.useState(false); // future use
  const open = Boolean(anchorEl);

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (disabled) return;
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <button
        type="button"
        className="platform-post-menu-btn"
        onClick={handleClick}
        aria-controls={open ? "platform-post-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disabled={disabled}
      >
        {loading ? <CircularProgress size={16} /> : <SubMenuThreeDotIcon />}
      </button>

      <Menu
        id="platform-post-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="custom-action-menu"
        PaperProps={{
          elevation: 3,
          sx: {
            borderRadius: "10px",
            mt: 1,
            width: 220,
            boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <MenuItem onClick={() => { handleClose(); onPublishNow?.(); }}>
          Publish now
        </MenuItem>

        <MenuItem onClick={() => { handleClose(); onSchedulePost?.(); }}>
          Schedule post
        </MenuItem>

        <MenuItem onClick={() => { handleClose(); onCancelSchedule?.(); }}>
          Cancel schedule
        </MenuItem>

        <MenuItem onClick={() => { handleClose(); onRetryPost?.(); }}>
          Retry post
        </MenuItem>

        <MenuItem onClick={() => { handleClose(); onViewErrors?.(); }}>
          View errors
        </MenuItem>
      </Menu>
    </>
  );
};

export default PropertyPlatformPostMenuIcon;